export default __webpack_public_path__ + "static/media/green-darken-historical.9e816030.svg";